import { render, staticRenderFns } from "./role-user-list.vue?vue&type=template&id=c1d5b0e0&scoped=true&"
import script from "./role-user-list.vue?vue&type=script&lang=js&"
export * from "./role-user-list.vue?vue&type=script&lang=js&"
import style0 from "./role-user-list.vue?vue&type=style&index=0&id=c1d5b0e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d5b0e0",
  null
  
)

export default component.exports